import React from 'react';
import '../App.css'
import Card from './card';
function search(){
    return(
        <div className="Home-main">
            <header className="Home-header">
                <input className="search-box" placeholder="" />
            </header>
            <div className="box">
            </div>
            <div className="container card-group">
                <div className="row">
                    <div className="col-md-6 flex-justify-center">
                        results
                    </div>
                    <div className="col-md-6 flex-justify-center">
                    </div>
                </div>
            </div>

        </div>
    );
}
export default search;
